import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../common/PageTrackerHelper'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  BasicSelect
} from 'vue-search-select';

export default {
  name: 'UpdatePODQueueFlags',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    PageTracker
  },
  mixins:[PageTracker],
  data: function() {
    return {
      ShipmentId: '',
      shipmenttype: [{
        text: "RTO"
      }, {
        text: "DTO"
      }],
      shipmentObj: {
        text: ""
      },
      srId:'',
      shipment: '',
      isLoading: false,
      poddata:[],
      isUpdateDisabled : true,
      userDataKey : ''
    }
  },
  created: function() {

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    //console.log('Mixin is working for :',result);
  },
  methods: {
    async updatepod() {
      let error = await this.$validator.validateAll()
      if(!error)
      {
        return
      }
      this.poddata = false;
      let payload = {
      SRID : this.srId,
      ShipmetType : this.shipment,
      OprType : 'Update'
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/get/update/PODQueueFlags',
          data: payload
        })
        .then(result => {
          if (result.data.code == 200) {
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.localuserid,
              username:this.localusermailid,
              meta: {
                "event":"updatePODQueueFlags",
                "SRID" : this.srId,
                "ShipmetType" : this.shipment,
                "OprType" : 'Update'
              }
            }
            this.PageTracker(TrackerInfo);
              this.$alertify.success(result.data.message);
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
          this.clear();
        })
    },
    async getpod() {
      let error = await this.$validator.validateAll()
      if(!error)
      {
        return
      }
      let payload = {
      SRID : this.srId,
      ShipmetType : this.shipment,
      OprType : 'Get'
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/get/update/PODQueueFlags',
          data: payload
        })
        .then(result => {
          if (result.data.code == 200) {
              this.isUpdateDisabled = false;
              this.poddata = result.data.data.rows
              this.$alertify.success(result.data.message);
          } else {
            this.poddata = [];
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
        })
    },
    SelectShipmentType(obj) {
      this.shipmentObj = obj;
      this.shipment = obj.text;
    },
    clear() {
      this.$validator.reset();
      this.srId = '';
      this.shipmentObj = {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdatePODQueueFlags/UpdatePODQueueFlags.component.js